export function scrollToRoom(roomNumber: string) {
  const element = document.getElementById(`room-${roomNumber}`);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}